module.exports = __webpack_public_path__ + "static/media/spring.01947612.jpg";